var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/badges/heart.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-heart\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.2 12.8\">\n    <title id=\"icon-heart\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["heart-image"])), env.opts.autoescape);
output += "\n    </title>\n\n    <path class=\"i-heart__heart-path\" d=\"M5.7 11.2c0.4 0.4 0.9 0.6 1.4 0.6 0.5 0 1-0.2 1.4-0.6l4.1-4.1c1.4-1.4 1.4-3.7 0-5.1 -1.4-1.4-3.7-1.4-5.1 0L7.1 2.4 6.7 2.1c-1.4-1.4-3.7-1.4-5.1 0 -1.4 1.4-1.4 3.7 0 5.1L5.7 11.2z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/badges/heart.j2"] , dependencies)